import { render, staticRenderFns } from "./OpenFiltersSidebar.vue?vue&type=template&id=95d11a2e"
import script from "./OpenFiltersSidebar.vue?vue&type=script&lang=js"
export * from "./OpenFiltersSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports